import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx, jsxs } from 'react/jsx-runtime';

var Svg18CoverG = /*#__PURE__*/React.memo(function (props) {
  var theme = useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), {}, {
    children: /*#__PURE__*/jsxs("g", {
      fill: "none",
      fillRule: "evenodd",
      stroke: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.colorV2.colorSet.grey400,
      children: [/*#__PURE__*/jsx("path", {
        d: "M14.017 14.256H6.724v-2.674a.953.953 0 0 0-.953-.953h-.005l-3.19.015V2.816c0-.527.427-.953.954-.953h7.696l1.846 1.78.002.001 1.896 1.837v7.822a.953.953 0 0 1-.953.953z"
      }), /*#__PURE__*/jsx("path", {
        fill: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.themeMode.lightPalette.colorSet.white1000,
        d: "M3.53 2.244h7.292v2.674c0 .526.427.953.954.953h.004l3.19-.015v8.993a.953.953 0 0 1-.953.953H3.53a.953.953 0 0 1-.953-.953V3.197c0-.526.426-.953.953-.953z"
      }), /*#__PURE__*/jsx("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.1,
        d: "M8.7 6.6v.55m0 1.65v3.3"
      })]
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg18CoverG$1 = Svg18CoverG;

export { Svg18CoverG$1 as default };
